import { colors } from "../../Styles";

export function Address({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M141.73,4.75c-47.56,0-86.11,38.55-86.11,86.11,0,82.28,73.46,187.85,86.11,187.85s86.11-104.6,86.11-187.85c0-47.56-38.55-86.11-86.11-86.11ZM141.73,141.32c-29.17,0-52.81-23.64-52.81-52.81s23.64-52.81,52.81-52.81,52.81,23.64,52.81,52.81-23.64,52.81-52.81,52.81Z"/>
      <polygon points="104.19 86.22 118.42 86.22 118.42 122.21 134.17 122.21 134.17 96.04 149.3 96.04 149.3 122.21 165.04 122.21 165.04 86.22 179.28 86.22 141.73 48.68 104.19 86.22"/>
    </svg>
  );
}
